import usePageType from './pageTypeAtom';

export * from './pageTypeAtom';

export default usePageType;
